/**
 * Mirror of orchestrator-api AccountResponseDto. Keep in sync with
 * src/modules/accounts/dto/account-response.dto.ts.
 *
 * Funding accounts are tenant-held pools a prefunded program debits.
 * Creation is synchronous (Fincra round-trip) — a listed account always
 * has a real NUBAN on `externalAccountRef`.
 */

export type AccountStatus = 'active' | 'frozen' | 'closed' | 'delinquent';

export const ACCOUNT_STATUS_LABEL: Record<AccountStatus, string> = {
  active: 'Active',
  frozen: 'Frozen',
  closed: 'Closed',
  delinquent: 'Delinquent',
};

export const ACCOUNT_STATUS_TONE: Record<AccountStatus, string> = {
  active: 'bg-tally-tint text-tally',
  frozen: 'bg-surface-margin text-ink-secondary',
  closed: 'bg-surface-margin text-ink-watermark',
  delinquent: 'bg-stop-tint text-stop',
};

export interface Account {
  id: string;
  tenantId: string;
  label: string;
  currency: string;
  status: AccountStatus;
  ledgerBalanceId: string | null;
  provider: string | null;
  externalAccountRef: string | null;
  accountName: string | null;
  createdAt: string;
  updatedAt: string;
}
